import { Button, ButtonProps } from "@chakra-ui/react";
import React, { useState } from "react";
import { resendVerificationEmail } from "src/generated/hooks/form-service/requests";
import { useAuth0ClientId } from "src/hooks/useAuth0ClientId";
import { useAvelaToast } from "src/hooks/useAvelaToast";
import useUser from "src/hooks/useUser";
import { EmailVerificationOverride, Status } from "src/types/authData";

type Props = ButtonProps & {
  emailVerificationOverrider?: EmailVerificationOverride;
};
export const ResendEmailVerificationButton: React.FC<Props> = (props) => {
  const user = useUser();
  const toast = useAvelaToast();
  const clientIdRD = useAuth0ClientId();

  let secondaryIdentity = {};
  if (props.emailVerificationOverrider?.type === "secondary-identity") {
    secondaryIdentity = {
      userId: props.emailVerificationOverrider.userId,
      provider: props.emailVerificationOverrider.provider,
    };
  }

  const [isResending, setIsResending] = useState(false);

  return (
    <Button
      variant="outline"
      width="100%"
      isLoading={isResending}
      onClick={async () => {
        if (
          (user.status !== Status.OK && user.status !== Status.NOT_VERIFIED) ||
          !clientIdRD.hasData()
        ) {
          toast.error({ title: "Unable to resend verification link" });
          return;
        }
        try {
          setIsResending(true);
          await resendVerificationEmail({
            body: {
              userId: user.data.id,
              clientId: clientIdRD.data.clientId,
              secondaryIdentity,
            },
          });
          toast({ title: "Link resent", status: "info", isClosable: true });
        } catch (err: unknown) {
          console.error(err);
          toast.error({ title: "Unable to resend verification link" });
        } finally {
          setIsResending(false);
        }
      }}
    >
      Resend
    </Button>
  );
};
